import toAccountUrl from 'helpers/account/toAccountUrl';
import { useFormat } from 'helpers/hooks/useFormat';
import { Order } from 'shared/types/cart';
import { ShipmentState } from 'types/entity/order';

interface Props {
  order: Order;
}

const OrderReturnButton: React.FC<Props> = ({ order }) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    order && (
      <>
        {/* Return button - only show if order is complete and shipped */}
        {order.orderState === 'Complete' && order.shipmentState === ShipmentState.SHIPPED && (
          <div className="flex justify-end pt-4">
            <a
              href={toAccountUrl(`?hash=returns&id=return_${order?.orderId}`)}
              className="inline-block rounded-sm bg-primary-black px-4 py-2 text-[14px] font-medium text-white transition-colors hover:bg-secondary-black"
            >
              {formatMessage({ id: 'order.startReturn', defaultMessage: 'Effettua un reso' })}
            </a>
          </div>
        )}
      </>
    )
  );
};

export default OrderReturnButton;
